import service from "../../../lib";
import { AxiosResponse } from "axios";

interface GetProductParams {
  [key: string]: string | number | boolean; 
}

export type ProductResponse<T = any> = AxiosResponse<T>;

const productApi = {
  getProduct: (
    { params }: { params: GetProductParams }
  ): Promise<ProductResponse<any>> => 
    service.get(`/product`, {
      params,
    }),
};

export default productApi;
